import { render, staticRenderFns } from "./DocumentContainer.vue?vue&type=template&id=f2ec2086&"
import script from "./DocumentContainer.vue?vue&type=script&lang=js&"
export * from "./DocumentContainer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports